import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import { reducer as aislesReducer } from './slices/aisles';
import { reducer as botMessagesReducer } from './slices/bot_messages';
import { reducer as brandsReducer } from './slices/brands';
import { reducer as categoriesReducer } from './slices/categories';
import { reducer as filtersReducer } from './slices/filter';
import { reducer as imagesReducer } from './slices/images';
import { reducer as navigationReducer } from './slices/navigation';
import { reducer as networkReducer } from './slices/network';
import { reducer as viewsReducer } from './slices/views';
import { reducer as productsReducer } from './slices/products';
import { reducer as searchReducer } from './slices/search';
import { reducer as sessionReducer } from './slices/session';
import { reducer as storesReducer } from './slices/stores';
import { reducer as tasksReducer } from './slices/tasks';
import { reducer as tasksModificationReducer } from './slices/tasks_modification';
import { reducer as ticketsReducer } from './slices/tickets';
import { reducer as usersReducer } from './slices/users';
import { reducer as floatingButtonReducer } from './slices/utils/floatingButton';
import { reducer as snackbarReducer } from './slices/utils/snackbar';
import { reducer as snackAlertReducer } from './slices/snackAlert';
import { reducer as excelReducer } from './slices/excel';
import { reducer as resourcesOverheadReducer } from './slices/resources_overhead';
import { reducer as resourcesTaskDetailsFeaturesReducer } from './slices/resources_task_details_features';

export default function _createStore(services) {
  return createStore(
    combineReducers({
      session: sessionReducer,
      stores: storesReducer,
      tasks: tasksReducer,
      tasksModification: tasksModificationReducer,
      images: imagesReducer,
      aisles: aislesReducer,
      filters: filtersReducer,
      snackbar: snackbarReducer,
      snackAlert: snackAlertReducer,
      floatingButton: floatingButtonReducer,
      navigation: navigationReducer,
      search: searchReducer,
      products: productsReducer,
      categories: categoriesReducer,
      users: usersReducer,
      tickets: ticketsReducer,
      botMessages: botMessagesReducer,
      brands: brandsReducer,
      network: networkReducer,
      views: viewsReducer,
      excel: excelReducer,
      resourcesOverhead: resourcesOverheadReducer,
      resourcesTaskDetailsFeatures: resourcesTaskDetailsFeaturesReducer,
    }),
    applyMiddleware(thunk.withExtraArgument({ services })),
  );
}
